import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import SignUpLayer from "../components/SignUpLayer";
import AccountService from "../services/api/auth";
import LicenseService from "../services/LicenseService";

const SignUpPage = () => {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [registeredUser, setRegisteredUser] = useState(null);
  const navigate = useNavigate();

  const handleSignUp = async (credentials) => {
    setLoading(true);
    try {
      console.log('📋 Enviando dados de cadastro:', credentials);
      
      // Se tem licença, usar o novo sistema
      if (credentials.licenseCode) {
        const response = await LicenseService.registerUser({
          name: credentials.name,
          email: credentials.email,
          password: credentials.password,
          phone: credentials.phone,
          cpf: credentials.cpf
        }, credentials.licenseCode);
        
        if (response.success) {
          setRegisteredUser(response.user);
          setShowSuccessModal(true);
          console.log('✅ Cadastro com licença realizado com sucesso!', response);
        } else {
          toast.error(response.message || 'Erro no cadastro');
        }
      } else {
        // Usar sistema antigo se não tem licença
        const response = await AccountService.register(credentials);
        console.log('✅ Resposta do cadastro:', response);
        
        if (response.success) {
          setRegisteredUser(response.user);
          setShowSuccessModal(true);
          console.log('✅ Cadastro realizado com sucesso!', response);
        } else {
          toast.error(response.message || 'Erro no cadastro');
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error during user registration:", error);
      toast.error('Erro no cadastro: ' + (error.response?.data?.message || error.message));
      throw error;
    }
  };

  // Função para ir para login
  const goToLogin = () => {
    setShowSuccessModal(false);
    navigate('/');
  };

  return (
    <>
      {/* SignUpLayer */}
      <SignUpLayer handleSignUp={handleSignUp} loading={loading} />

      {/* Modal de Sucesso */}
      <Modal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0 text-center">
          <Modal.Title className="w-100 text-center">
            <div className="text-success mb-3">
              <i className="ri-check-circle-fill" style={{ fontSize: '4rem' }}></i>
            </div>
            <h4 className="text-success">Cadastro Realizado!</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p className="mb-3">
            Olá <strong>{registeredUser?.name}</strong>! 
          </p>
          <p className="text-muted">
            Sua conta foi criada com sucesso. 
            Agora você pode fazer login e começar a usar nossa plataforma.
          </p>
          <div className="bg-light p-3 rounded mt-3">
            <small className="text-muted">
              <strong>Email:</strong> {registeredUser?.email}
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center">
          <Button 
            variant="success" 
            onClick={goToLogin}
            className="px-5"
          >
            Ir para Login
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SignUpPage;
